import PropTypes from 'prop-types';

export const TLSAccountPropTypes = PropTypes.shape({
  periodName: PropTypes.string.isRequired,
  account: PropTypes.string,
  description: PropTypes.string,
  enabledFlag: PropTypes.string.isRequired,
});

export const TLSAccountsPropTypes = PropTypes.arrayOf(TLSAccountPropTypes).isRequired;
